import React from "react";
import ReactDOM from "react-dom/client";
import SalcoAPP from "./SalcoAPP";
import { BrowserRouter as Router } from "react-router-dom";
import { ClearCacheProvider } from "react-clear-cache";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

import "./CSS/Custom.css";
import "./CSS/Main.css";
import "./CSS/Loading.css";
import "bootstrap/dist/css/bootstrap.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ClearCacheProvider duration={60000}>
    <Router>
      {/* <React.StrictMode> */}
      <SalcoAPP />
      {/* </React.StrictMode> */}
    </Router>
  </ClearCacheProvider>
);

serviceWorkerRegistration.unregister();
reportWebVitals();
